import { useEffect, useRef } from "react";
import { useServiceWorker } from "@/hooks/useServiceWorker";
import { useUiStore } from "@/stores/ui.store";

export function UpdatePrompt() {
  const { isUpdateAvailable, update } = useServiceWorker();
  const addToast = useUiStore((s) => s.addToast);
  const hasShownToast = useRef(false);

  useEffect(() => {
    if (!isUpdateAvailable || hasShownToast.current) return;
    hasShownToast.current = true;
    addToast({
      type: "info",
      message: "A new version is live.",
      action: {
        label: "Reload",
        onClick: () => update(),
      },
    });
  }, [isUpdateAvailable, addToast, update]);

  return null;
}
